'use client'

import type React from 'react'
import { useRef } from 'react'
import CatalogCartButton from './CatalogCartButton'
import { useNavbarBottom, usePinnedBelowNavbar } from './quoteCartDock'

/** The catalog search and quote cart, pinned under the navbar while the catalog scrolls */
export default function MarketplaceSearchBar({ children }: { children: React.ReactNode }) {
  const navbarBottom = useNavbarBottom()
  const markerRef = useRef<HTMLDivElement>(null)
  const pinned = usePinnedBelowNavbar(markerRef)

  return (
    <>
      <div ref={markerRef} aria-hidden="true" />
      <div
        style={{ '--marketplace-bar-top': `${navbarBottom}px` } as React.CSSProperties}
        className="sticky top-[var(--marketplace-bar-top)] z-20 -mx-4 -mt-3 px-4 py-3 lg:mx-0 lg:px-0">
        {/* One frosted layer fades out below the search bar (and past its sides); it shows only while pinned so it never sits over content at rest */}
        <div
          aria-hidden="true"
          className={`pointer-events-none absolute -bottom-6 left-0 right-0 top-0 -z-10 bg-secondary-gray-10/60 backdrop-blur-md transition-opacity duration-200 motion-reduce:transition-none ${pinned ? 'opacity-100' : 'opacity-0'} [mask-image:linear-gradient(to_bottom,black_55%,transparent)] lg:-left-6 lg:-right-6 lg:[-webkit-mask-composite:source-in] lg:[mask-composite:intersect] lg:[mask-image:linear-gradient(to_bottom,black_55%,transparent),linear-gradient(to_right,transparent,black_24px,black_calc(100%-24px),transparent)]`}
        />
        <div className="flex items-center gap-3">
          <div className="min-w-0 flex-1">{children}</div>
          <CatalogCartButton />
        </div>
      </div>
    </>
  )
}
